/* eslint-disable react/jsx-no-literals */
import React from "react";
import PropTypes from "prop-types";
import { generate } from "shortid";

import "./Dots.scss";
// import createRange from "../../utils/createRange";

const createRange = length => {
  const result = [];

  for (let i = 0; i < length; i++) {
    result.push(length);
  }

  return result;
}


const Dots = ({ length, isHorizontal }) => {
  const range = createRange(length);

  return (
    <div className={`dots ${isHorizontal ? "dots--vertical" : ""}`}>
      {range.map(() => (
        <div
          key={generate()}
          className={`dots__dot ${isHorizontal ? "dots__dot--vertical" : ""} `}
        />
      ))}
    </div>
  );
};

Dots.propTypes = {
  isHorizontal: PropTypes.bool,
  length: PropTypes.number
};

Dots.defaultProps = {
  isHorizontal: false,
  length: 3
};

export default Dots;
